import type { StepListPassThroughOptions } from "primevue/steplist";

export const steplist: StepListPassThroughOptions = {
  root: "relative flex justify-between items-center m-0 p-0 list-none"
};
